import CustomsInformation from './customsInformation';

export default CustomsInformation;
